import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/information.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import InformationCommunity from '@/components/Information/InformationCommunity/InformationCommunity';
import InformationCommunityForm from '@/components/Information/InformationCommunity/InformationCommunityForm/InformationCommunityForm';
import InformationNotice from '@/components/Information/InformationNotice/InformationNotice.tsx';
import {
	INFORMATION_MENU_COMMUNITY,
	INFORMATION_MENU_NOTICE,
	INFORMATION_STEP_CREATE,
	INFORMATION_STEP_EDIT,
	normalizeInformationMenu,
	normalizeInformationStep,
} from '@/constants/information';

const menuList = [INFORMATION_MENU_NOTICE, INFORMATION_MENU_COMMUNITY];

const Membership = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const params = normalizeInformationMenu(location.state?.menu);
	const stepParams = normalizeInformationStep(location.state?.step);

	const handleSetMenu = (menu: string) => {
		navigate('/information', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="information.page.bannerSubtitle" title="information.page.bannerTitle" img={mainBanner} />
			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === INFORMATION_MENU_NOTICE && <InformationNotice />}
			{params === INFORMATION_MENU_COMMUNITY && stepParams !== INFORMATION_STEP_CREATE && stepParams !== INFORMATION_STEP_EDIT && <InformationCommunity />}
			{params === INFORMATION_MENU_COMMUNITY && (stepParams === INFORMATION_STEP_CREATE || stepParams === INFORMATION_STEP_EDIT) && (
				<InformationCommunityForm />
			)}
		</main>
	);
};

export default Membership;
